
  import { defineComponent } from 'vue'

  import BikePic from '@/components/BikePic.vue'
  import LoginOrRegisterForm from '@/components/User/UserAuthForm.vue'

  export default defineComponent({
    name: 'NavBar',
    components: {
      BikePic,
      LoginOrRegisterForm,
    },
    props: {
      action: {
        type: String,
        required: true,
      },
    },
  })
